/* eslint-disable react/no-unescaped-entities */
import CombinedHero from '../components/CombinedHero';
import HomeFeatures from '../components/HomeFeatures';
import HomeFeaturesThree from '../components/HomeFeaturesThree';
import PokemonCta from '../components/PokemonCta';
import PokemonFeaturesTwo from '../components/PokemonFeaturesTwo';
import PricingSection from '../components/PricingSection';
import { SEO } from '../components/seo';

export default function Home() {
  return (
    <article>
      <SEO translationKey='seo.home' />
      <CombinedHero />
      <HomeFeatures />
      <PokemonFeaturesTwo />
      <HomeFeaturesThree />
      <PricingSection />
      <PokemonCta />
    </article>
  );
}
